import gql from 'graphql-tag';
import {
  MINIMAL_BUSINESS_FRAGMENT,
  BUSINESS_DETAILS_FRAGMENT,
} from './fragment';
import { USER_INFO_FRAGMENT } from '../user/fragment';

export const GET_ALL_BUSINESSES = gql`
  query AllBusinesses($input: AllBusinessesInput) {
    allBusinesses(input: $input) {
      totalCount
      businesses {
        ...BusinessInfo
        apa {
          ...UserInfo
          agencies {
            id
            name
          }
        }
        mandatary {
          ...UserInfo
        }
      }
    }
  }
  ${MINIMAL_BUSINESS_FRAGMENT}
  ${USER_INFO_FRAGMENT}
`;

export const GET_BUSINESS_DETAILS = gql`
  query GetBusinessDetails($id: Int!) {
    getBusiness(id: $id) {
      ...BusinessDetailsInfo
    }
  }
  ${BUSINESS_DETAILS_FRAGMENT}
`;
